import config from '@/config';
import useCache from '@/hooks/useCache';
import useTranslations from '@/i18n/useTranslations';
import Loader from '@/shared-components/loader/Loader'; 
import ActivityHeading from '@/shared-components/text/components/ActivityHeading';
import Text from '@/shared-components/text/components/Text';
import { filterRenderableThoughts } from '@/utils/activityContent';

import VirtualList from './components/VirtualList';

import './index.css';

export default function LikedThoughts() {
  const t = useTranslations('common.profile.activity');
  const { loading, fetchData, setFetchData, loadMoreData } = useCache("liked_thoughts", `${config.apis.api.url}/thoughts/liked`, {
    injectToken: true,
    expiresIn: ["0", "seconds"]
  });
  const visibleThoughts = filterRenderableThoughts(fetchData?.data);

  return (
    <>
      <ActivityHeading text={t('menu.liked_thoughts')}/>
      <div className="activity-liked-thoughts__container">
        {
          loading ? 
            <Loader />  
            : visibleThoughts.length === 0 ? 
              <Text className="activity-liked-thoughts__text font-size-medium">
                {t('empty.liked_thoughts')}
              </Text>
              :
              <VirtualList
                items={fetchData}
                visibleItems={visibleThoughts}
                setItems={setFetchData}
                onLoadMore={loadMoreData}
                cacheKey="liked_thoughts"
              />
        }
      </div>
    </>
  );
}
